import { useCallback, useEffect, useRef, useState } from 'react';

export interface UseTruncatedReturn {
  truncated: boolean;
  setElement: (element: HTMLElement | null) => void;
}

export const useTruncated = (): UseTruncatedReturn => {
  const [truncated, setTruncated] = useState(false);
  const [element, setElement] = useState<HTMLElement | null>(null);
  const resizeObserver = useRef<ResizeObserver | null>();

  const update = useCallback(() => {
    setTruncated(element ? element.scrollWidth > element.offsetWidth : false);
  }, [element]);

  useEffect(() => {
    if (element && !resizeObserver.current) {
      resizeObserver.current = new ResizeObserver(() => {
        window.requestAnimationFrame(() => {
          update();
        });
      });

      resizeObserver.current.observe(element);

      return () => {
        if (resizeObserver.current) resizeObserver.current.unobserve(element);
      };
    }
  }, [element, update]);

  useEffect(() => {
    update();
  }, [update]);

  return { truncated, setElement };
};
